import React, { useState } from "react";
import OrganisationLayout from "../organisation/layout/OrganisationLayout";
import BaseButton from "../base/BaseButton";
import ArrowDown from "../../assets/icons/ArrowDown.svg";
import OldOrders from "../order/OldOrders";
import OldResultList from "./OldResultList";
import { Order } from "../../store/slices/order/types";

const OldResultsIndex = () => {
  const [showResult, setShowResult] = useState<boolean>(false);
  const [selectedOrder, setSelectedOrder] = useState<Order | null>(null);

  const closeResult = () => {
    setShowResult(false);
    setSelectedOrder(null);
  };

  return (
    <OrganisationLayout>
      <div className="m-12">
        <h1 className="text-xl text-[#0C4654] font-bold mb-8">Old Results</h1>
        {showResult ? (
          <>
            <div className="mb-4 mx-6">
              <BaseButton
                text="Return to Orders"
                variant="neutral"
                hasLeftIcon
                styles="!px-5 !h-10 !text-[0.875rem] border border-green-800 textbrandColor"
                click={closeResult}
              >
                <img
                  src={ArrowDown}
                  alt="green dot icon"
                  className="w-[15px] rotate-90 xl:w-[20px] mr-2"
                />
              </BaseButton>
            </div>

            <div className="bg-[#F2F6FA] border-[1px] border-[#E5E9F2] rounded-[1rem] py-8 px-4 lg:px-6">
              <div>
                <OldResultList oldOrder={selectedOrder} />
              </div>
            </div>
          </>
        ) : (
          <OldOrders
            setShowResult={setShowResult}
            setSelectedOrder={setSelectedOrder}
          />
        )}
      </div>
    </OrganisationLayout>
  );
};

export default OldResultsIndex;
